module.exports = __webpack_public_path__ + "pix-buyBlue.svg?6917005c24ee831ec73deb3589c3349c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/pix-buyBlue.svg
// module id = 383
// module chunks = 2